import applications from 'locales/dental/th/application/application.json'
import news from 'locales/dental/th/application/news.json'
import promotions from 'locales/dental/th/application/promotion.json'
import manageWeb from 'locales/dental/th/application/manageWeb.json'

export const Application = {
  ...applications,
  ...news,
  ...promotions,
  ...manageWeb
}
